import { render, staticRenderFns } from "./SetupTickets.vue?vue&type=template&id=b489ef20"
import script from "./SetupTickets.vue?vue&type=script&lang=js"
export * from "./SetupTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports